import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { IDaily, IWeatherApiClient } from '../api/adaptiveActionClient/interface';
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';
import { zustandWeatherStore } from '../mmkv/mmkvWeatherStore';

type AppSettings = {
  weatherClientApiDetail: IWeatherApiClient;
  setWeatherClientApiDetail: (weather: IWeatherApiClient) => void;
  weatherActionData: IDaily;
  setWeatherActionData: (weather: IDaily) => void;
};

export const useWeatherStore = create<AppSettings>()(
  persist(
    (set, get) => ({
      weatherClientApiDetail: get()?.weatherClientApiDetail,
      setWeatherClientApiDetail: (weather: IWeatherApiClient) =>
        set(() => ({ weatherClientApiDetail: weather })),
      weatherActionData: get()?.weatherActionData,
      setWeatherActionData: (weather: IDaily) => set(() => ({ weatherActionData: weather })),
    }),
    {
      name: MMKVStoreKeyMap.weatherStore,
      storage: createJSONStorage(() => zustandWeatherStore),
    }
  )
);
